import MultistepQuotation from '@hebeta/multistepquotation/js/MultistepQuotation';
import MultistepQuotationDealerSelect from '@hebeta/multistepquotation/js/MultistepQuotationDealerSelect';

new MultistepQuotation();
new MultistepQuotationDealerSelect();
